function ForgotPassword() {
  return <div>This is Forgot Password</div>;
}

export default ForgotPassword;
